import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-square-delicious",
  "use": "icon-si-glyph-square-delicious-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-square-delicious\" id=\"icon-si-glyph-square-delicious\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>993</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M1,0 L1,16 L17,16 L17,0 L1,0 L1,0 Z M8.938,15.016 L8.938,8.01 L1.959,8.01 L1.959,0.958 L9.01,0.958 L9.01,7.969 L16.016,7.969 L16.016,15.016 L8.938,15.016 L8.938,15.016 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-square-delicious.svg
// module id = G6+Y
// module chunks = 62